import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/CustomMeetingRoom.css'
const CustomMeetingRoom = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const jitsiContainerRef = useRef(null);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const meetingLink = searchParams.get('link');

    if (!meetingLink) {
      console.error('No meeting link provided');
      navigate('/dashboard');
      return;
    }

    const domain = 'meet.jit.si';
    const options = {
      roomName: new URL(meetingLink).pathname.split('/').pop(),
      width: '100%',
      height: '600px',
      parentNode: jitsiContainerRef.current,
      interfaceConfigOverwrite: {
        TOOLBAR_BUTTONS: [
          'microphone', 'camera', 'closedcaptions', 'desktop', 'fullscreen',
          'fodeviceselection', 'hangup', 'profile', 'chat', 'recording',
          'livestreaming', 'etherpad', 'sharedvideo', 'settings', 'raisehand',
          'videoquality', 'filmstrip', 'invite', 'feedback', 'stats', 'shortcuts',
          'tileview', 'videobackgroundblur', 'download', 'help', 'mute-everyone',
          'security'
        ],
      },
    };

    const api = new window.JitsiMeetExternalAPI(domain, options);

    api.addEventListeners({
      readyToClose: handleClose,
      participantLeft: handleParticipantLeft,
      participantJoined: handleParticipantJoined,
      videoConferenceJoined: handleVideoConferenceJoined,
      videoConferenceLeft: handleVideoConferenceLeft,
    });

    return () => api.dispose();
  }, [location, navigate]);

  const handleClose = () => {
    console.log("Meeting closed");
    navigate('/dashboard');
  };

  const handleParticipantLeft = (participant) => {
    console.log("Participant left", participant);
  };

  const handleParticipantJoined = (participant) => {
    console.log("Participant joined", participant);
  };

  const handleVideoConferenceJoined = (participant) => {
    console.log("Video conference joined", participant);
  };

  const handleVideoConferenceLeft = () => {
    console.log("Video conference left");
    navigate('/dashboard');
  };

  return (
    <div className="flex h-screen bg-gray-100">
      <div className="flex-1 flex flex-col overflow-hidden">
        <header className="bg-white shadow-sm z-10">
          <div className="max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8">
            <h1 className="text-2xl font-semibold text-gray-900">Akademix Meeting Room</h1>
          </div>
        </header>
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-200">
          <div className="container mx-auto px-6 py-8">
            <div className="bg-white shadow-md rounded-lg overflow-hidden">
              <div ref={jitsiContainerRef} className="w-full h-[600px]" />
            </div>
            <div className="mt-6 flex justify-center">
              <button
                onClick={handleClose}
                className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
              >
                Leave Meeting
              </button>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default CustomMeetingRoom;